import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import "../Style/Transaction.css";
import { BASE_URL } from "../Apis/apiConfig";
import { FaEdit, FaTrash } from "react-icons/fa";

const Transaction = () => {
  const [transactions, setTransactions] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedMessage, setSelectedMessage] = useState("");
  const [editModal, setEditModal] = useState(false);
const [editId, setEditId] = useState(null);
const [editMessage, setEditMessage] = useState("");
const [editImage, setEditImage] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const societyName = localStorage.getItem("society");

        const response = await axios.post(
          `${BASE_URL}/back/get-payment-data?societyName=${societyName}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        setTransactions(response.data);
      } catch (error) {
        console.log("Error:", error);
      }
    };

    fetchData();
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const updatePaymentStatus = async (paymentId, isPayment) => {
  try {
    const token = localStorage.getItem("token");

    await axios.post(
      `${BASE_URL}/back/set-payment-recive-member?paymentId=${paymentId}&isPayment=${isPayment}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // 🔥 Update UI instantly
    setTransactions((prev) =>
      prev.map((item) =>
        item.paymentId === paymentId
          ? { ...item, isPayment: isPayment }
          : item
      )
    );

  } catch (error) {
    console.log("Error updating payment:", error);
  }
};
const handleEdit = (item) => {
  setEditId(item.paymentId);
  setEditMessage(item.message || "");
  setEditModal(true);
};

const updateTransaction = async () => {
  try {
    const token = localStorage.getItem("token");

    const formData = new FormData();
    formData.append("paymentId", editId);
    formData.append("message", editMessage);

    if (editImage) {
      formData.append("screenShootImage", editImage);
    }

    await axios.post(
      `${BASE_URL}/back/edit-payment-transaction-data`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // update UI
    setTransactions((prev) =>
      prev.map((item) =>
        item.paymentId === editId
          ? { ...item, message: editMessage }
          : item
      )
    );

    setEditModal(false);

  } catch (error) {
    console.log("Edit error:", error);
  }
};

const deleteTransaction = async (paymentId) => {
  try {
    const token = localStorage.getItem("token");

    await axios.delete(
      `${BASE_URL}/back/delete-payment-transaction?paymentId=${paymentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // remove from UI
    setTransactions((prev) =>
      prev.filter((item) => item.paymentId !== paymentId)
    );

  } catch (error) {
    console.log("Delete error:", error);
  }
};




  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

        <main className="content-area">
          <SubHeader />

          <div className="table-container">
        
            <table className="transaction-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Date</th>
                  <th>Member</th>
                   <th>Verfiy</th> 
                  <th>Unit</th>
                  <th>Message</th>
                  <th>Image</th>
                </tr>
              </thead>

           <tbody>
  {transactions.length > 0 ? (
    transactions.map((item) => (
      <tr key={item.paymentId}>  
      <td>{item.paymentId}</td>
          <td>{item.createDate}</td>
        <td>{item.memberName}</td>
    <td>
    {item.verifyPayment ? (
      <span style={{ color: "green", fontWeight: "bold" }}>
         Received
      </span>
    ) : (
      <button
        style={{
          padding: "5px 10px",
          backgroundColor: "#16a34a",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
        }}
        onClick={() => updatePaymentStatus(item.paymentId, true)}
      >
        Verify
      </button>
    )}
  </td>
        <td>{item.unitNo}</td>
        <td>
          {item.message && item.message.trim() !== "" ? (
            <button
              className="btn btn-read"
              onClick={() => setSelectedMessage(item.message)}
            >
              📄 Read
            </button>
          ) : (
            <span className="empty">No Message</span>
          )}
        </td>
        <td>
          {item.screenShootImage ? (
            <button
              className="btn btn-view"
              onClick={() => setSelectedImage(item.screenShootImage)}
            >
              👁 View
            </button>
          ) : (
            <span className="empty">No Image</span>
          )}
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6" className="no-data">
        No Transactions Found
      </td>
    </tr>
  )}
</tbody>
            </table>
          </div>

          {selectedImage && (
            <div className="modal">
              <div className="modal-content">
                <span className="close" onClick={() => setSelectedImage(null)}>
                  ✖
                </span>
                <img
                  src={`data:image/jpeg;base64,${selectedImage}`}
                  alt="preview"
                  className="modal-img"
                />
              </div>
            </div>
          )}

          {selectedMessage && (
            <div className="modal">
              <div className="modal-content">
                <span className="close" onClick={() => setSelectedMessage("")}>
                  ✖
                </span>
                <p>{selectedMessage}</p>
              </div>
            </div>
          )}

        </main>
      </div>
    </div>
  );
};

export default Transaction;